module.exports = __webpack_public_path__ + "static/media/app3.b9d4192e.jpg";